import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import {MsalService} from "@azure/msal-angular";
import { AnexoDelegacion } from 'src/app/hojas-call-center/models/AnexoDelegacion';

@Injectable({
  providedIn: 'root'
})
@Injectable()
export class DelegacionService
{
  private hostPeticion : string = environment.delegacionesWSBase;

  constructor(private http: HttpClient,private msalService:MsalService){}

  public getDatosDelegacion(token:string,delegacion:number|string):Promise<AnexoDelegacion>
  {
    let url:string = this.hostPeticion + "/AnexoDelegaciones/"
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
    {
      parameters:
      [[{
        campo:"delegacion",
        operacion:"=",
        valor:delegacion+""
      }]]
    };
    return new Promise<AnexoDelegacion>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(response:any)
        {
          resolve(response[0]);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  getDelegaciones(token:string):Promise<AnexoDelegacion[]>
  {
    let url:string = this.hostPeticion + "/Delegacion/getJoin"
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
    {
      "parameters":
      [
        [
          {
            campo: "d.par_008",
            operacion: "<>",
            valor: "S"
          }
        ],
        [
          {
            campo: "d.par_010",
            operacion: "<>",
            valor: "S"
          }
        ]
      ],
      select: ["lpad(AD.delegacion::text,3,'00') as delegacion","ad.nombre as nombre", "ad.booking as booking","UPPER(ad.tipo) as tipo"],
      orden: [["ad.delegacion","ASC"]]
    };

    return new Promise<AnexoDelegacion[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(value:any)
        {
          resolve(value);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  getDelegacionesMafre(token:string):Promise<AnexoDelegacion[]>
  {
    let url:string = this.hostPeticion + "/Delegacion/getJoin"
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [
              {
                campo: "d.delegacion",
                operacion: "IN",
                valor2: ["13","34","43","53","99","146","173","227","268","291"]
              }
            ]
          ],
        select: ["lpad(AD.delegacion::text,3,'00') as delegacion","ad.nombre as nombre","ad.booking as booking"],
        orden: [["ad.delegacion","ASC"]]
      };

    return new Promise<AnexoDelegacion[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(value:any)
          {
            resolve(value);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          }
        });
    });
  }

  getDelegacionesRepa(token:string):Promise<AnexoDelegacion[]>
  {
    let url:string = this.hostPeticion + "/Delegacion/getJoin"
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };

    let arrParams =
      {
        "parameters":
          [
            [
              {
                campo: "d.delegacion",
                operacion: "<>",
                valor: "970"
              }
            ],
            [
              {
                campo: "d.par_008",
                operacion: "<>",
                valor: "S"
              }
            ],
            [
              {
                campo: "d.par_010",
                operacion: "<>",
                valor: "S"
              },
              {
                campo: "d.delegacion",
                operacion: ">=",
                valor: "400"
              }
            ],
            [
              {
                campo: "d.par_010",
                operacion: "<>",
                valor: "S"
              },
              {
                campo: "d.delegacion",
                operacion: "<",
                valor: "500"
              }
            ]
          ],
        select: ["lpad(AD.delegacion::text,3,'00') as delegacion","ad.nombre as nombre","ad.booking as booking"],
        orden: [["ad.delegacion","ASC"]]
      };

    return new Promise<AnexoDelegacion[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(value:any)
          {
            resolve(value);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          }
        });
    });
  }

  getDelegacionesExclude(token:string, taller: string[]):Promise<AnexoDelegacion[]>
  {
    let url:string = this.hostPeticion + "/Delegacion/getJoin"
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    let arrParams =
      {
        "parameters":
          [
            [
              {
                campo: "d.par_008",
                operacion: "<>",
                valor: "S"
              }
            ],
            [
              {
                campo: "d.par_010",
                operacion: "<>",
                valor: "S"
              }
            ],
            [
              {
                campo: "d.delegacion",
                operacion: "NOT IN",
                valor: "",
                valor2: taller
              }
            ]
          ],
        select: ["lpad(AD.delegacion::text,3,'00') as delegacion","ad.nombre as nombre","ad.booking as booking"],
        orden: [["ad.delegacion","ASC"]]
      };
    return new Promise<AnexoDelegacion[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(value:any)
          {
            resolve(value);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          }
        });
    });
  }
  //recogemos delegaciones con los parametros que le pasemos de forma generica
  getDelegacionesCustom(token:string, arrParams:any):Promise<AnexoDelegacion[]>
  {
    let url:string = this.hostPeticion + "/Delegacion/getJoin"

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }).set('Authorization', 'Bearer ' + token),
      params: new HttpParams({})
    };
    return new Promise<AnexoDelegacion[]>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(response:any)
        {
          resolve(response);
        },
        error(err)
        {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  public getAvisoTaller(token: string, taller: any){
    let url: string = environment.callCenterWSBase +"/Calendari";
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }
    let today = new Date().toISOString().split('T')[0]
    let arrParams=
      {
        "parameters": [
          [
            {
              "campo": "empresa",
              "operacion": "=",
              "valor": parseInt(taller).toString()
            }
          ],
          [
            {
              "campo": "fecha",
              "operacion": "=",
              "valor": today
            }
          ]
        ],
        "select": [
          "*"
        ],
        "orden": [
          [
            "num",
            "ASC"
          ]
        ]
    };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public getCalendarioTaller(token: string, taller: number){
    let url: string = environment.delegacionesWSBase +"/CalendarioIdTalleres";
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    let arrParams=
      {
        "parameters": [
          [
            {
              "campo": "taller",
              "operacion": "=",
              "valor": taller.toString()
            }
          ]
        ],
        "select": [
          "url_compartida"
        ]
      };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public disponibilidadDias(delegacion:string){
    let url= "https://workshops.ralarsa.com/ssl/wsRalarsa/webralarsa/disponibilidadhoras";

    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let cuerpo = `tipo=0&delegacion=${delegacion}&user=axa&password=axaProvider5673`;

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url, cuerpo, { headers: headers, responseType: 'json' })
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
    //return this.http.post(url, cuerpo, { headers: headers, responseType: 'json' });
  }

  public disponibilidadHoras(delegacion:string, dia:string){
    let url= "https://workshops.ralarsa.com/ssl/wsRalarsa/webralarsa/disponibilidadhoras";

    let headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let cuerpo = `tipo=1&dia=${dia}&delegacion=${delegacion}&user=axa&password=axaProvider5673`;

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url, cuerpo, { headers: headers, responseType: 'json' })
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
    //return this.http.post(url, cuerpo, { headers: headers, responseType: 'json' });
  }

}
export interface InfoTaller{
  delegacion: string,
  nombre: string
}
